import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function FinalCtaSection() {
  return <section className="py-0 bg-white px-4 relative overflow-hidden border-t border-gray-100" data-id="element-96">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-100/50 rounded-full blur-[120px] pointer-events-none" data-id="element-97" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-99">
          <div className="w-20 h-20 bg-brand-50 rounded-2xl flex items-center justify-center mx-auto mb-8 rotate-3 shadow-sm border border-brand-100" data-id="element-100">
            <Zap className="w-10 h-10 text-brand-500 -rotate-3" data-id="element-101" />
          </div>

          <h2 className="text-4xl md:text-6xl font-heading font-extrabold mb-6 text-gray-900" data-id="element-102">
            ⚡ MEGA PACK <br className="hidden md:block" data-id="element-103" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-500 to-brand-400" data-id="element-104">
              ELECTRICIDAD EN CASA
            </span>
          </h2>

          <p className="text-2xl text-gray-800 font-bold mb-4" data-id="element-105">
            Aprendé a resolver vos las cosas de tu casa.
          </p>

          <p className="text-xl text-gray-500 font-medium mb-12" data-id="element-106">
            Podés seguir llamando a alguien… o podés aprender a hacerlo vos.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-107">
            <a href="#pricing" className="w-full sm:w-auto px-8 py-4 bg-white border-2 border-brand-200 hover:border-brand-400 hover:bg-brand-50 text-brand-600 font-bold rounded-2xl transition-colors text-lg" data-id="element-108">
              📘 → QUIERO EL PLAN BÁSICO
            </a>
            <a href="#pricing" className="w-full sm:w-auto px-8 py-4 bg-brand-500 hover:bg-brand-600 text-white font-bold rounded-2xl transition-all transform hover:scale-105 shadow-[0_8px_30px_rgba(236,72,153,0.3)] text-lg" data-id="element-109">
              🏆 → QUIERO EL PLAN PREMIUM
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}